import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../include/layout";
import "../../scss/pages/form.scss";
import "../../scss/pages/forgotpassword.scss";
import { reset_password } from "../../data/api";
import MessageModal from "../customcomponents/messageModal";
import { Form } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";
import Widthcontainer from "../customcomponents/widthcontainer";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import SeoTags from "../../utils/seoTags";
import Login_img from "../../assets/refer.png";

const ResetPassword = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    // Get reset data from session storage
    const [resetData, setResetData] = useState(null);
    useEffect(() => {
        const data = sessionStorage.getItem('passwordReset');
        if (!data) {
            navigate('/login');
            return;
        }
        setResetData(JSON.parse(data));
    }, []);

    const schema = yup.object().shape({
        password: yup
            .string()
            .required("Password is required")
            .matches(
                /^(?!.* )(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?([^\w\s]|[_])).{8,}$/,
                "Must contain 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character with no whitespace"
            ),
        confirmPassword: yup
            .string()
            .required("Confirm Password is required")
            .oneOf([yup.ref("password")], "Passwords do not match"),
    });

    const handleSubmit = async (values) => {
        try {
            const response = await reset_password(
                resetData.resetToken,
                values.password,
                values.confirmPassword
            );

            if (response.status === 200) {
                setSuccess(true);
                setMessage("Password has been reset successfully");
                sessionStorage.removeItem('passwordReset');
                navigate('/login', { replace: true })
            } else {
                setError(true);
                setMessage(response?.response?.data?.message || "Failed to reset password");
            }
        } catch (err) {
            setError(true);
            setMessage(err?.response?.data?.message || "An error occurred");
        }
    };

    return (
        <Layout>
            {SeoTags(
                "Reset Password | DishHome Nepal",
                "Reset Your DishHome Password",
                "Reset your DishHome account password securely",
                "reset password, account password, DishHome password",
                "",
                `${process.env.REACT_APP_PUBLIC_URL}reset-password`
            )}
            <MessageModal
                show={error}
                setShow={setError}
                type="error"
                heading="Reset Failed"
                message={message}
                buttonText="OK"
            />
            <MessageModal
                show={success}
                setShow={setSuccess}
                type="success"
                heading="Success"
                message={message}
                buttonText="OK"
                link="/login"
                isNavigate={true}
                replace={true}
            />
            <Widthcontainer>
                <div className={"ForgotPassword_Wrapper fixed-width my-4"}>
                    <div className={"ForgotPassword_Form"}>
                        <div className={"ForgotPassword_Container"}>
                            <h1 className={"ForgotPassword_Header"}>Reset Password</h1>
                            <h3 className={"ForgotPassword_Text"}>
                                Please enter a new password for your account.
                            </h3>

                            <Formik
                                validationSchema={schema}
                                onSubmit={handleSubmit}
                                initialValues={{
                                    password: "",
                                    confirmPassword: "",
                                }}
                            >
                                {({ handleSubmit, handleChange, values, touched, errors }) => (
                                    <Form
                                        id="dashboard-formwidth"
                                        className={"ForgotPassword_Container"}
                                        noValidate
                                        onSubmit={handleSubmit}
                                    >
                                        <div className={"Password_Container"}>
                                            <Form.Label>New Password</Form.Label>
                                            <Form.Control
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                className={"Email_Input"}
                                                autoComplete="new-password"
                                                style={{ paddingRight: "38px" }}
                                                onChange={handleChange}
                                                value={values?.password}
                                                onPaste={(e) => {
                                                    e.preventDefault();
                                                    return false;
                                                }}
                                            />
                                            {!showPassword ? (
                                                <AiOutlineEyeInvisible
                                                    size={19}
                                                    className={"Pw_Icon"}
                                                    onClick={() => setShowPassword(true)}
                                                />
                                            ) : (
                                                <AiOutlineEye
                                                    size={19}
                                                    className={"Pw_Icon"}
                                                    onClick={() => setShowPassword(false)}
                                                />
                                            )}
                                            {errors?.password && touched.password && (
                                                <p className="error_message" style={{ color: "#ed1c24" }}>
                                                    {errors?.password}
                                                </p>
                                            )}
                                        </div>

                                        <div className={"Password_Container"}>
                                            <Form.Label>Confirm Password</Form.Label>
                                            <Form.Control
                                                type={showConfirmPassword ? "text" : "password"}
                                                name="confirmPassword"
                                                className={"Email_Input"}
                                                autoComplete="new-password"
                                                style={{ paddingRight: "38px" }}
                                                onChange={handleChange}
                                                value={values?.confirmPassword}
                                                onPaste={(e) => {
                                                    e.preventDefault();
                                                    return false;
                                                }}
                                            />
                                            {!showConfirmPassword ? (
                                                <AiOutlineEyeInvisible
                                                    size={19}
                                                    className={"Pw_Icon"}
                                                    onClick={() => setShowConfirmPassword(true)}
                                                />
                                            ) : (
                                                <AiOutlineEye
                                                    size={19}
                                                    className={"Pw_Icon"}
                                                    onClick={() => setShowConfirmPassword(false)}
                                                />
                                            )}
                                            {errors?.confirmPassword && touched.confirmPassword && (
                                                <p className="error_message" style={{ color: "#ed1c24" }}>
                                                    {errors?.confirmPassword}
                                                </p>
                                            )}
                                        </div>

                                        <button className={"ForgotPassword_Button"} type="submit">
                                            Reset Password
                                        </button>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                    <div className={"Login_Image"}>
                        <img src={Login_img} alt="" />
                    </div>
                </div>
            </Widthcontainer>
        </Layout>
    );
};

export default ResetPassword;